import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import AuthImage from "../../components/AuthImage";

const TAREAS_LABEL = {
  limpieza_hab: "Limpieza habitación",
  lavado_ropa: "Lavado de ropa",
  planchado: "Planchado",
  banos: "Baños",
  salon: "Salón",
  cocina: "Cocina",
};
const TAREAS_ICONO = {
  limpieza_hab: "🛏️",
  lavado_ropa: "👕",
  planchado: "👔",
  banos: "🚿",
  salon: "🛋️",
  cocina: "🍳",
};
const TAREAS_CON_ALUMNO = ["limpieza_hab", "lavado_ropa", "planchado"];
const TAREAS_TOGGLE = ["banos", "salon", "cocina"]; // solo 0/1, sin foto
const TAREAS_SIN_FOTO = ["limpieza_hab", "lavado_ropa", "planchado"]; // quitar fotos
const TODAS_TAREAS = Object.keys(TAREAS_LABEL);

const EjecucionPiso = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const piso = state?.piso;

  const [plan, setPlan] = useState(null);
  const [ejecucion, setEjecucion] = useState(null);
  const [alumnos, setAlumnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activo, setActivo] = useState(null);
  const [loadingAction, setLoadingAction] = useState(false);
  const [modalCambio, setModalCambio] = useState({ open: false, esExtra: false, tarea_orig: null, hab_orig_id: null });
  const [nuevaTarea, setNuevaTarea] = useState("");
  const [nuevoAlumno, setNuevoAlumno] = useState(undefined);
  const [modalCierre, setModalCierre] = useState(false);
  const [modalConfirmCierre, setModalConfirmCierre] = useState(false);
  const [comentarioCierre, setComentarioCierre] = useState("");
  const [confirmacionCierre, setConfirmacionCierre] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const [modalFoto, setModalFoto] = useState(null);
  const [incidenciasSeleccionadas, setIncidenciasSeleccionadas] = useState([]);
  const [incidenciasTipos, setIncidenciasTipos] = useState([]);
  const [incidenciasOpen, setIncidenciasOpen] = useState(false);
  const [incidenciasTexto, setIncidenciasTexto] = useState('');
  const incidenciasTextoTimerRef = useRef(null);
  const [opcionesExtra, setOpcionesExtra] = useState([]);
  const [opcionesNoHecho, setOpcionesNoHecho] = useState({});
  const [razonNoHecho, setRazonNoHecho] = useState({}); // { tarea: id_opcion }
  const [modalNoHecho, setModalNoHecho] = useState(null); // tarea que se está marcando como no hecho
  const [extrasSeleccionados, setExtrasSeleccionados] = useState([]); // [{ key, tarea_real, hab_id?, label }]
  const [tareaExtraAbierta, setTareaExtraAbierta] = useState(null);

  // Guardar incidencias en tiempo real (sin cerrar)
  const guardarIncidencias = useCallback(async (ids, texto, ejec) => {
    if (!ejec || ejec.cerrado) return;
    try {
      await axios.post('/api/servicio/ejecucion/incidencias', {
        id_ejecucion: ejec.id,
        incidencias: ids.length > 0 ? ids : null,
        incidencias_texto: texto.trim() || null,
      });
    } catch { /* silencioso */ }
  }, []);

  const toggleIncidencia = (tipo, ejec) => {
    setIncidenciasSeleccionadas(prev => {
      const next = prev.includes(tipo.id) ? prev.filter(id => id !== tipo.id) : [...prev, tipo.id];
      guardarIncidencias(next, incidenciasTexto, ejec);
      return next;
    });
  };

  const onIncidenciasTextoChange = (e, ejec) => {
    const val = e.target.value;
    setIncidenciasTexto(val);
    if (incidenciasTextoTimerRef.current) clearTimeout(incidenciasTextoTimerRef.current);
    incidenciasTextoTimerRef.current = setTimeout(() => {
      guardarIncidencias(incidenciasSeleccionadas, val, ejec);
    }, 800);
  };

  const cargar = useCallback(async () => {
    if (!piso) return;
    try {
      setLoading(true);
      setError("");
      const [res, resTipos, resExtras] = await Promise.all([
        axios.get(`/api/servicio/dia_completo/${piso.id}`),
        incidenciasTipos.length === 0 ? axios.get('/api/servicio/incidencias_opciones') : Promise.resolve(null),
        opcionesExtra.length === 0 ? axios.get('/api/servicio/opciones_extras') : Promise.resolve(null),
      ]);
      if (resTipos) setIncidenciasTipos(resTipos.data || []);
      if (resExtras) setOpcionesExtra(resExtras.data || []);
      const { plan: p, ejecucion: ejec, alumnos: alms } = res.data;
      setPlan(p);
      setAlumnos(alms || []);
      if (p && !ejec) {
        try {
          await axios.post("/api/servicio/ejecucion/abrir", { id_planificado: p.id });
          const res2 = await axios.get(`/api/servicio/dia_completo/${piso.id}`);
          setEjecucion(res2.data.ejecucion);
        } catch {
          setEjecucion(null);
        }
      } else {
        setEjecucion(ejec);
        // Restaurar incidencias si ya estaban guardadas
        if (ejec && !ejec.cerrado) {
          if (Array.isArray(ejec.incidencias) && ejec.incidencias.length > 0)
            setIncidenciasSeleccionadas(ejec.incidencias);
          if (ejec.incidencias_texto)
            setIncidenciasTexto(ejec.incidencias_texto);
        }
      }
    } catch {
      setError("No se pudo cargar el piso.");
    } finally {
      setLoading(false);
    }
  }, [piso]);

  // Cargar opciones no-hecho para una tarea cuando se abre el modal
  const cargarOpcionesNoHecho = async (tarea) => {
    if (opcionesNoHecho[tarea]) return;
    try {
      const res = await axios.get(`/api/servicio/opciones_no_hecho?tarea=${tarea}`);
      setOpcionesNoHecho(prev => ({ ...prev, [tarea]: res.data || [] }));
    } catch {
      setOpcionesNoHecho(prev => ({ ...prev, [tarea]: [] }));
    }
  };

  useEffect(() => { cargar(); }, [cargar]);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!piso) {
    return (
      <div style={s.page}>
        <button onClick={() => navigate("/asistenta")} style={s.btnVolver}>← Volver</button>
        <p style={{ color: "#dc2626" }}>Error: no se recibieron datos del piso.</p>
      </div>
    );
  }

  const tareasActivas = plan
    ? TODAS_TAREAS.filter(t => {
        if (t === "limpieza_hab") return plan.limpieza_hab_id != null;
        if (t === "lavado_ropa") return plan.lavado_ropa_id != null;
        if (t === "planchado") return plan.planchado_id != null;
        if (t === "banos") return plan.banos === 1 || plan.banos === "1";
        if (t === "salon") return plan.salon === 1 || plan.salon === "1";
        if (t === "cocina") return plan.cocina === 1 || plan.cocina === "1";
        return false;
      })
    : [];

  const valOk = (t) => {
    const v = ejecucion?.[`${t}_ok`];
    if (TAREAS_TOGGLE.includes(t)) return v === 1 || v === "1" || v === true ? "si" : (v === 0 || v === "0" ? "no" : null);
    return v;
  };

  const canCerrar =
    ejecucion &&
    !ejecucion.cerrado &&
    tareasActivas.length > 0 &&
    tareasActivas.every(t => {
      const v = valOk(t);
      return v === "si" || v === "no" || v === "cambio";
    });

  const extrasDisponibles = TODAS_TAREAS.filter(t => {
    if (t === "limpieza_hab") return plan?.limpieza_hab_id == null;
    if (t === "lavado_ropa") return plan?.lavado_ropa_id == null;
    if (t === "planchado") return plan?.planchado_id == null;
    if (t === "banos") return !(plan?.banos === 1 || plan?.banos === "1");
    if (t === "salon") return !(plan?.salon === 1 || plan?.salon === "1");
    if (t === "cocina") return !(plan?.cocina === 1 || plan?.cocina === "1");
    return false;
  });

  const accion = async (fn) => {
    setLoadingAction(true);
    try { await fn(); await cargar(); }
    catch (e) { alert("Error: " + (e.response?.data?.error || e.message)); }
    finally { setLoadingAction(false); }
  };

  const marcarTarea = (tarea, estado) =>
    accion(() => axios.post("/api/servicio/ejecucion/estado", { id_ejecucion: ejecucion.id, tarea, estado }));

  const subirFoto = (tarea, tipo, file) => {
    setModalFoto(null);
    accion(async () => {
      const fd = new FormData();
      fd.append("id_ejecucion", ejecucion.id);
      fd.append("tarea", tarea);
      fd.append("tipo", tipo);
      fd.append("file", file);
      await axios.post("/api/servicio/foto", fd);
    });
  };

  const borrarFoto = (id) => {
    if (!window.confirm("¿Borrar foto?")) return;
    accion(() => axios.delete(`/api/servicio/foto/${id}`));
  };

  const borrarCambio = (id, tarea_original) => {
    if (!window.confirm("¿Borrar este cambio/extra?")) return;
    accion(async () => {
      await axios.delete(`/api/servicio/ejecucion/cambio/${id}`);
      if (tarea_original && ejecucion) {
        const otrosCambios = (ejecucion.cambios || []).filter(c => c.id !== id && c.tarea_original === tarea_original);
        if (otrosCambios.length === 0) {
          await axios.post("/api/servicio/ejecucion/estado", { id_ejecucion: ejecucion.id, tarea: tarea_original, estado: null });
        }
      }
    });
  };

  const abrirTarea = (tarea) => {
    setActivo(prev => {
      const next = prev === tarea ? null : tarea;
      if (next) {
        setTimeout(() => {
          const el = document.getElementById(`tarea-${next}`);
          if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 16;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }, 80);
      }
      return next;
    });
  };

  const marcarNoHecho = async (tarea) => {
    if (TAREAS_SIN_FOTO.includes(tarea)) {
      await cargarOpcionesNoHecho(tarea);
      setModalNoHecho(tarea);
    } else {
      accion(() => axios.post("/api/servicio/ejecucion/estado", { id_ejecucion: ejecucion.id, tarea, estado: valOk(tarea) === "no" ? null : "no" }));
    }
  };

  const confirmarNoHecho = (tarea) => {
    const razon = razonNoHecho[tarea];
    if (!razon) { alert("Selecciona una razón"); return; }
    setModalNoHecho(null);
    accion(() => axios.post("/api/servicio/ejecucion/estado", { id_ejecucion: ejecucion.id, tarea, estado: "no", razon_id: razon }));
    setActivo(null);
  };

  const marcarHecho = (tarea) => {
    accion(async () => {
      await axios.post("/api/servicio/ejecucion/estado", { id_ejecucion: ejecucion.id, tarea, estado: valOk(tarea) === "si" ? null : "si" });
      setActivo(null);
    });
  };

  const marcarToggle = (tarea) => {
    const actual = valOk(tarea);
    const nuevo = actual === "si" ? "no" : "si";
    accion(async () => {
      await axios.post("/api/servicio/ejecucion/estado", { id_ejecucion: ejecucion.id, tarea, estado: nuevo });
      setActivo(null);
    });
  };

  const abrirModalCambio = (tarea, hab_id) => {
    setModalCambio({ open: true, esExtra: false, tarea_orig: tarea, hab_orig_id: hab_id || null });
    setNuevaTarea(tarea);
    setNuevoAlumno(undefined);
  };

  const abrirModalExtra = () => {
    setModalCambio({ open: true, esExtra: true, tarea_orig: null, hab_orig_id: null });
    setNuevaTarea("");
    setNuevoAlumno(undefined);
    setExtrasSeleccionados([]);
    setTareaExtraAbierta(null);
  };

  const cerrarModal = () => {
    setModalCambio({ open: false });
    setNuevaTarea("");
    setNuevoAlumno(undefined);
    setExtrasSeleccionados([]);
  };

  const toggleExtraSelec = (key, tarea_real, hab_id, label) => {
    setExtrasSeleccionados(prev =>
      prev.find(x => x.key === key)
        ? prev.filter(x => x.key !== key)
        : [...prev, { key, tarea_real, hab_id, label }]
    );
  };

  const confirmarCambio = () => {
    if (modalCambio.esExtra) {
      if (extrasSeleccionados.length === 0) { alert("Selecciona al menos un extra"); return; }
      cerrarModal();
      setActivo(null);
      accion(async () => {
        for (const item of extrasSeleccionados) {
          const body = { id_ejecucion: ejecucion.id, tarea_real: item.tarea_real };
          if (item.hab_id) body.hab_id = item.hab_id;
          await axios.post("/api/servicio/ejecucion/cambio", body);
        }
      });
      return;
    }
    if (!nuevaTarea) { alert("Selecciona una tarea"); return; }
    const body = { id_ejecucion: ejecucion.id, tarea_real: nuevaTarea };
    body.tarea_original = modalCambio.tarea_orig;
    if (modalCambio.hab_orig_id) body.hab_original_id = modalCambio.hab_orig_id;
    if (nuevoAlumno !== undefined && nuevoAlumno !== null && nuevoAlumno !== '') body.hab_id = parseInt(nuevoAlumno, 10);
    cerrarModal();
    setActivo(null);
    accion(async () => {
      if (modalCambio.tarea_orig) {
        await axios.post("/api/servicio/ejecucion/estado", {
          id_ejecucion: ejecucion.id,
          tarea: modalCambio.tarea_orig,
          estado: "cambio",
        });
      }
      await axios.post("/api/servicio/ejecucion/cambio", body);
    });
  };

  const cerrarPiso = (valoracion) => {
    accion(async () => {
      await axios.post("/api/servicio/ejecucion/cerrar", {
        id_ejecucion: ejecucion.id,
        ...(comentarioCierre ? { comentario_cierre: comentarioCierre } : {}),
        valoracion,
        incidencias: incidenciasSeleccionadas.length > 0 ? incidenciasSeleccionadas : null,
        ...(incidenciasTexto.trim() ? { incidencias_texto: incidenciasTexto.trim() } : {}),
      });
      setModalCierre(false);
      setComentarioCierre("");
      setIncidenciasSeleccionadas([]);
      setIncidenciasTexto('');
      setIncidenciasOpen(false);
      setConfirmacionCierre(valoracion);
    });
  };

  const renderFotos = (tarea, tipo) => {
    if (TAREAS_SIN_FOTO.includes(tarea)) return null;
    const fotas = (ejecucion?.fotos || []).filter(f => f.tarea === tarea && f.tipo === tipo);
    const label = tipo === "antes" ? "📷 Antes" : "📸 Después";
    return (
      <div style={s.fotoFila}>
        <span style={s.fotoTipoLabel}>{label}</span>
        <div style={s.fotoList}>
          {fotas.map(f => (
            <div key={f.id} style={s.fotoItem}>
              <AuthImage
                src={`/servicio_fotos/${f.filename}`}
                alt={tipo}
                style={s.fotoThumb}
                onClick={() => setLightbox(`/servicio_fotos/${f.filename}`)}
              />
              {!ejecucion.cerrado && (
                <button style={s.btnFotoDel} onClick={() => borrarFoto(f.id)} title="Borrar foto">✕</button>
              )}
            </div>
          ))}
          {!ejecucion?.cerrado && (
            <button style={s.btnFotoAdd} onClick={() => setModalFoto({ tarea, tipo })}>+</button>
          )}
        </div>
      </div>
    );
  };

  const renderTarea = (tarea) => {
    const ok = valOk(tarea);
    const isToggle = TAREAS_TOGGLE.includes(tarea);
    const tieneAlumno = TAREAS_CON_ALUMNO.includes(tarea);
    const alumnoId = tieneAlumno ? plan[`${tarea}_id`] : null;
    const alumnoHab = tieneAlumno ? plan[`${tarea}_hab`] : null;
    const alumnoNombre = tieneAlumno ? plan[`${tarea}_nombre`] : null;
    const alumnoInfo = tieneAlumno && alumnoId ? `${alumnoHab} · ${alumnoNombre}` : null;
    const cambios = (ejecucion?.cambios || []).filter(c => c.tarea_original === tarea);
    const fotos = (ejecucion?.fotos || []).filter(f => f.tarea === tarea);
    const isOpen = activo === tarea;
    const borderColor = ok === "si" ? "#16a34a" : ok === "no" ? "#dc2626" : ok === "cambio" ? "#d97706" : "#d1d5db";
    const bgColor = ok === "si" ? "#f0fdf4" : ok === "no" ? "#fff1f2" : ok === "cambio" ? "#fffbeb" : "#fff";
    const okLabel = ok === "si" ? "✅ Hecho" : ok === "no" ? "❌ No hecho" : ok === "cambio" ? "🔄 Cambiado" : null;
    const razon = ok === "no" ? ejecucion?.[`${tarea}_razon`] : null;

    return (
      <div key={tarea} id={`tarea-${tarea}`} style={{ ...s.tareaCard, borderLeft: `6px solid ${borderColor}`, background: bgColor }}>
        <div style={{ ...s.tareaHeader, cursor: "pointer" }} onClick={() => abrirTarea(tarea)}>
          <span style={s.tareaIcono}>{TAREAS_ICONO[tarea]}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={s.tareaLabel}>{TAREAS_LABEL[tarea]}</div>
            {alumnoInfo && <div style={s.tareaAlumno}>{alumnoInfo}</div>}
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4, flexShrink: 0 }}>
            <div style={{ ...s.okBadge, color: okLabel ? borderColor : "#9ca3af", borderColor: okLabel ? borderColor : "#e2e8f0" }}>
              {okLabel || "Sin marcar"}
            </div>
            {razon && <div style={{ fontSize: 12, fontWeight: 700, color: "#dc2626", maxWidth: 120, textAlign: "right", lineHeight: 1.2 }}>{razon}</div>}
            {(fotos.length > 0 || cambios.length > 0) && (
              <div style={{ fontSize: 12, color: "#6b7280" }}>
                {fotos.length > 0 && `📷${fotos.length} `}{cambios.length > 0 && `🔄${cambios.length}`}
              </div>
            )}
            <span style={{ fontSize: 13, color: "#9ca3af" }}>{isOpen ? "▲" : "▼"}</span>
          </div>
        </div>
        {isOpen && (
          <div style={s.tareaBody}>
            {/* Razon no hecho */}
            {razon && (
              <div style={{ background: "#fee2e2", border: "2px solid #fca5a5", borderRadius: 12, padding: "10px 14px", marginBottom: 12, fontSize: 15, fontWeight: 700, color: "#b91c1c" }}>
                Razón: {razon}
              </div>
            )}
            {/* 1. FOTOS primero */}
            {!TAREAS_SIN_FOTO.includes(tarea) && (
              <div style={s.fotosSection}>
                {renderFotos(tarea, "antes")}
                {renderFotos(tarea, "despues")}
              </div>
            )}
            {/* 2. CAMBIOS existentes */}
            {cambios.length > 0 && (
              <div style={s.cambiosList}>
                {cambios.map(c => (
                  <div key={c.id} style={s.cambioCard}>
                    <div style={s.cambioCardRow}>
                      <div style={s.cambioParte}>
                        <div style={s.cambioParteLabel}>Plan</div>
                        <div style={s.cambioParteVal}>{TAREAS_ICONO[tarea]} {TAREAS_LABEL[tarea]}{alumnoInfo ? ` · ${alumnoInfo}` : ""}</div>
                      </div>
                      <div style={s.cambioArrow}>→</div>
                      <div style={s.cambioParte}>
                        <div style={s.cambioParteLabel}>Real</div>
                        <div style={s.cambioParteVal}>{TAREAS_ICONO[c.tarea_real] || "⭐"} {TAREAS_LABEL[c.tarea_real] || c.tarea_real}{c.hab_real_hab ? ` · ${c.hab_real_hab} ${c.hab_real_nombre}` : ""}</div>
                      </div>
                    </div>
                    {!ejecucion.cerrado && (
                      <button style={{ ...s.btnDel, marginTop: 8, width: "100%" }} onClick={() => borrarCambio(c.id, c.tarea_original)}>✕ Borrar cambio</button>
                    )}
                  </div>
                ))}
              </div>
            )}
            {/* 3. BOTONES Hecho/No hecho/Cambiar */}
            {!ejecucion?.cerrado && (
              <div style={{ paddingTop: 10 }}>
                {tieneAlumno && (
                  <button
                    style={{ ...s.btnCambiar, width: "100%", marginBottom: 10, ...(cambios.length > 0 ? s.btnCambiarDis : {}) }}
                    onClick={() => abrirModalCambio(tarea, alumnoId)}
                    disabled={loadingAction || cambios.length > 0}
                  >
                    🔄 Cambiar habitación
                  </button>
                )}
                <div style={s.btnGrupo}>
                  <button
                    style={{ ...s.btnMarca, ...(ok === "si" ? s.btnHechoActivo : s.btnHecho) }}
                    onClick={() => marcarHecho(tarea)}
                    disabled={loadingAction}
                  >
                    ✅ Hecho
                  </button>
                  <button
                    style={{ ...s.btnMarca, ...(ok === "no" ? s.btnNoHechoActivo : s.btnNoHecho) }}
                    onClick={() => marcarNoHecho(tarea)}
                    disabled={loadingAction}
                  >
                    ❌ No hecho
                  </button>
                </div>
              </div>
            )}
            {ok === "cambio" && !ejecucion?.cerrado && (
              <button style={s.btnDesmarcar} onClick={() => marcarTarea(tarea, null)} disabled={loadingAction}>
                ✕ Quitar marca
              </button>
            )}
          </div>
        )}
      </div>
    );
  };

  const extras = (ejecucion?.cambios || []).filter(c => !c.tarea_original);

  return (
    <div style={s.page}>
      <div style={s.cabecera}>
        <button style={s.btnVolver} onClick={() => navigate("/asistenta")}>← Volver</button>
        <div style={s.cabeceraInfo}>
          <div style={s.pisoTitulo}>{piso.abreviatura}</div>
          {piso.hora_entrada && (
            <div style={s.pisoHorario}>⏱ {piso.hora_entrada.slice(0, 5)} – {(piso.hora_salida || "").slice(0, 5)}</div>
          )}
        </div>
      </div>
      {loading ? (
        <div style={s.centrado}>Cargando…</div>
      ) : error ? (
        <div style={s.errorBox}>{error}</div>
      ) : !plan ? (
        <div style={s.vacioBx}>
          <div style={{ fontSize: 52 }}>📋</div>
          <div style={s.vacioTitulo}>Sin planificación para hoy</div>
          <div style={s.vacioSub}>La supervisora debe planificar este piso primero.</div>
        </div>
      ) : (
        <>
          {!!ejecucion?.cerrado && (
            <div style={s.cerradoBanner}>
              <div style={{ fontSize: 42 }}>{ejecucion.valoracion === "bien" ? "👍" : "👎"}</div>
              <div style={s.cerradoTitulo}>Piso cerrado</div>
              {ejecucion.comentario_cierre && (
                <div style={s.cerradoComent}>"{ejecucion.comentario_cierre}"</div>
              )}
            </div>
          )}
          {tareasActivas.length > 0 && (() => {
            const hechas = tareasActivas.filter(t => { const v = valOk(t); return v === "si" || v === "no" || v === "cambio"; }).length;
            const total = tareasActivas.length;
            const pct = Math.round((hechas / total) * 100);
            return (
              <div style={s.progresoBx}>
                <div style={s.progresoTexto}>📋 {hechas} de {total} tareas completadas</div>
                <div style={s.progresoBarFondo}>
                  <div style={{ ...s.progresoBar, width: `${pct}%` }} />
                </div>
              </div>
            );
          })()}
          {tareasActivas.length === 0 ? (
            <div style={s.vacioBx}><div style={s.vacioTitulo}>No hay tareas planificadas</div></div>
          ) : (
            <div style={s.tareasList}>{tareasActivas.map(t => renderTarea(t))}</div>
          )}
          {/* EXTRAS */}
          {(extras.length > 0 || (ejecucion && !ejecucion.cerrado)) && (
            <div style={s.extrasSection}>
              <div style={s.seccionTitulo}>⭐ Extras</div>
              {extras.map(c => (
                <div key={c.id} style={s.extraItem}>
                  <span style={{ flex: 1 }}>
                    {TAREAS_ICONO[c.tarea_real] || "⭐"}{" "}
                    {TAREAS_LABEL[c.tarea_real] || c.tarea_real}
                    {c.hab_real_hab ? ` · ${c.hab_real_hab} ${c.hab_real_nombre}` : ""}
                  </span>
                  {!ejecucion?.cerrado && (
                    <button style={s.btnDel} onClick={() => borrarCambio(c.id, null)}>✕</button>
                  )}
                </div>
              ))}
              {!ejecucion?.cerrado && (
                <button style={s.btnExtra} onClick={abrirModalExtra} disabled={loadingAction}>
                  ➕ Añadir extra
                </button>
              )}
            </div>
          )}
          {/* INCIDENCIAS */}
          {ejecucion && !ejecucion.cerrado && incidenciasTipos.length > 0 && (
            <div style={{ ...s.extrasSection, background: '#fff7ed', border: '2px solid #fed7aa', borderRadius: 16, padding: 0, overflow: 'hidden', marginBottom: 20 }}>
              <button
                type="button"
                onClick={() => setIncidenciasOpen(o => !o)}
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 18px', background: 'transparent', border: 'none', cursor: 'pointer' }}
              >
                <span style={{ fontWeight: 900, fontSize: 22, color: '#9a3412' }}>
                  ⚠️ Incidencias {incidenciasSeleccionadas.length > 0 && <span style={{ background: '#ea580c', color: '#fff', borderRadius: 10, padding: '2px 8px', fontSize: 13, marginLeft: 6 }}>{incidenciasSeleccionadas.length}</span>}
                </span>
                <span style={{ fontSize: 20, color: '#ea580c', transition: 'transform 0.2s', transform: incidenciasOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>▾</span>
              </button>
              {incidenciasOpen && (
                <div style={{ padding: '0 18px 18px' }}>
                  <div style={{ fontSize: 16, color: '#92400e', marginBottom: 14 }}>Marca si hubo alguna incidencia hoy (opcional)</div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(105px, 1fr))', gap: 12 }}>
                    {incidenciasTipos.map(tipo => {
                      const sel = incidenciasSeleccionadas.includes(tipo.id);
                      return (
                        <button key={tipo.id} type="button"
                          onClick={() => toggleIncidencia(tipo, ejecucion)}
                          style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', gap: 6, padding: '14px 8px 12px', borderRadius: 14, border: '3px solid', borderColor: sel ? '#ea580c' : '#fed7aa', background: sel ? '#ea580c' : '#fff', cursor: 'pointer', width: '100%', minHeight: 110, boxShadow: sel ? '0 0 0 4px #fdba74, 0 4px 12px rgba(234,88,12,0.3)' : '0 2px 6px rgba(0,0,0,0.05)', transition: 'all 0.15s' }}
                        >
                          {sel && <span style={{ position: 'absolute', top: 6, right: 8, fontSize: 16, color: '#fff', fontWeight: 900, lineHeight: 1 }}>✓</span>}
                          <span style={{ fontSize: 36 }}>{tipo.emoji}</span>
                          <span style={{ fontSize: 14, fontWeight: 700, color: sel ? '#fff' : '#374151', textAlign: 'center', lineHeight: 1.2 }}>{tipo.titulo}</span>
                          {tipo.descripcion && <span style={{ fontSize: 11, color: sel ? 'rgba(255,255,255,0.85)' : '#6b7280', textAlign: 'center', lineHeight: 1.2 }}>{tipo.descripcion}</span>}
                        </button>
                      );
                    })}
                  </div>
                  <textarea
                    placeholder="Añade más detalles sobre la incidencia..."
                    value={incidenciasTexto}
                    onChange={e => onIncidenciasTextoChange(e, ejecucion)}
                    rows={3}
                    style={{ marginTop: 14, width: '100%', boxSizing: 'border-box', border: '1.5px solid #fed7aa', borderRadius: 10, padding: '10px 12px', fontSize: 15, color: '#374151', background: '#fff', resize: 'vertical', outline: 'none', fontFamily: 'inherit' }}
                  />
                </div>
              )}
            </div>
          )}
          {ejecucion && !ejecucion.cerrado && (
            <button
              style={{ ...s.btnCerrar, ...(canCerrar ? {} : s.btnCerrarDis) }}
              onClick={() => canCerrar && setModalConfirmCierre(true)}
              disabled={!canCerrar || loadingAction}
            >
              🔒 Cerrar piso
              {!canCerrar && <div style={s.cerrarHint}>Marca todas las tareas primero</div>}
            </button>
          )}
        </>
      )}

      {/* MODAL NO HECHO */}
      {modalNoHecho && (
        <div style={s.overlay} onClick={() => setModalNoHecho(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitulo}>❌ ¿Por qué no se pudo hacer?</div>
            <div style={{ fontSize: 17, color: '#6b7280', marginBottom: 18 }}>{TAREAS_ICONO[modalNoHecho]} {TAREAS_LABEL[modalNoHecho]}</div>
            {(opcionesNoHecho[modalNoHecho] || []).length === 0 ? (
              <div style={{ color: '#9ca3af', fontSize: 15, marginBottom: 20 }}>No hay razones configuradas. Contacta con la supervisora.</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 20 }}>
                {(opcionesNoHecho[modalNoHecho] || []).map(op => {
                  const sel = razonNoHecho[modalNoHecho] === op.id;
                  return (
                    <button key={op.id} type="button"
                      onClick={() => setRazonNoHecho(prev => ({ ...prev, [modalNoHecho]: op.id }))}
                      style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '18px 16px', borderRadius: 14, border: '2px solid', borderColor: sel ? '#dc2626' : '#e2e8f0', background: sel ? '#fff1f2' : '#fff', cursor: 'pointer', fontSize: 18, fontWeight: 700, color: sel ? '#b91c1c' : '#374151', textAlign: 'left' }}
                    >
                      <span style={{ fontSize: 26 }}>{op.emoji || '❌'}</span>
                      <span>{op.titulo}</span>
                    </button>
                  );
                })}
              </div>
            )}
            <div style={s.modalBtns}>
              <button style={s.btnModalCancel} onClick={() => setModalNoHecho(null)}>Cancelar</button>
              <button
                style={{ ...s.btnModalOk, ...(!razonNoHecho[modalNoHecho] ? { background: '#cbd5e1', color: '#94a3b8', cursor: 'not-allowed' } : { background: '#dc2626' }) }}
                disabled={!razonNoHecho[modalNoHecho]}
                onClick={() => confirmarNoHecho(modalNoHecho)}
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CAMBIO/EXTRA */}
      {modalCambio.open && (
        <div style={s.overlay} onClick={e => { if (e.target === e.currentTarget) cerrarModal(); }}>
          <div style={s.modal}>
            <div style={s.modalTitulo}>{modalCambio.esExtra ? "➕ Añadir extra" : "🔄 Cambiar tarea"}</div>
            {modalCambio.esExtra ? (
              <>
                {/* Sección 1: opciones libres de la BD */}
                {opcionesExtra.length > 0 && (
                  <div style={s.formGrupo}>
                    <label style={{ ...s.formLabel, fontSize: 15, color: '#6b7280', fontWeight: 700, marginBottom: 10 }}>Extras configurados</label>
                    <div style={s.tareaGrid}>
                      {opcionesExtra.map(op => {
                        const key = `db-${op.id}`;
                        const sel = !!extrasSeleccionados.find(x => x.key === key);
                        const yaExiste = extras.some(e => e.tarea_real === op.titulo);
                        return (
                          <button key={key} type="button"
                            style={{ ...s.tareaOpcion, ...(sel ? s.tareaOpcionActiva : {}), ...(yaExiste ? { opacity: 0.4, cursor: 'not-allowed' } : {}), position: 'relative' }}
                            onClick={() => !yaExiste && toggleExtraSelec(key, op.titulo, null, op.titulo)}
                            disabled={yaExiste}
                          >
                            {sel && <span style={{ position: 'absolute', top: 4, right: 6, fontSize: 14, color: '#1d4ed8', fontWeight: 900 }}>✓</span>}
                            {yaExiste && !sel && <span style={{ position: 'absolute', top: 4, right: 6, fontSize: 12, color: '#9ca3af', fontWeight: 900 }}>ya</span>}
                            <span style={{ fontSize: 28 }}>{op.emoji || "⭐"}</span>
                            <span style={s.tareaOpcionLabel}>{op.titulo}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
                {/* Sección 2: tareas con alumno no organizadas */}
                {["limpieza_hab", "lavado_ropa", "planchado"].map(tarea => {
                  const alumnosDisponibles = alumnos.filter(a => a.id_alumno !== plan?.[`${tarea}_id`]);
                  if (alumnosDisponibles.length === 0) return null;
                  const abierta = tareaExtraAbierta === tarea;
                  const nSel = extrasSeleccionados.filter(x => x.key.startsWith(`${tarea}-`)).length;
                  return (
                    <div key={tarea} style={{ ...s.formGrupo, marginBottom: 10 }}>
                      <button type="button"
                        onClick={() => setTareaExtraAbierta(abierta ? null : tarea)}
                        style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderRadius: 12, border: '2px solid', borderColor: abierta ? '#3b82f6' : nSel > 0 ? '#1d4ed8' : '#e2e8f0', background: abierta ? '#eff6ff' : nSel > 0 ? '#dbeafe' : '#f8fafc', cursor: 'pointer', fontFamily: 'inherit' }}
                      >
                        <span style={{ fontSize: 16, fontWeight: 700, color: abierta ? '#1d4ed8' : nSel > 0 ? '#1e3a5f' : '#374151' }}>
                          {TAREAS_ICONO[tarea]} {TAREAS_LABEL[tarea]}
                          {nSel > 0 && <span style={{ marginLeft: 8, background: '#1d4ed8', color: '#fff', borderRadius: 10, padding: '1px 8px', fontSize: 13 }}>{nSel}</span>}
                        </span>
                        <span style={{ fontSize: 18, color: '#6b7280' }}>{abierta ? '▲' : '▼'}</span>
                      </button>
                      {abierta && (
                        <div style={{ ...s.tareaGrid, marginTop: 10 }}>
                          {alumnosDisponibles.map(a => {
                            const key = `${tarea}-${a.id_alumno}`;
                            const sel = !!extrasSeleccionados.find(x => x.key === key);
                            const yaExiste = extras.some(e => e.tarea_real === tarea && String(e.hab_real_hab) === String(a.habitacion));
                            return (
                              <button key={key} type="button"
                                style={{ ...s.tareaOpcion, ...(sel ? s.tareaOpcionActiva : {}), ...(yaExiste ? { opacity: 0.4, cursor: 'not-allowed' } : {}), position: 'relative' }}
                                onClick={() => !yaExiste && toggleExtraSelec(key, tarea, a.id_alumno, `${TAREAS_LABEL[tarea]} · ${a.habitacion}`)}
                                disabled={yaExiste}
                              >
                                {sel && <span style={{ position: 'absolute', top: 4, right: 6, fontSize: 14, color: '#1d4ed8', fontWeight: 900 }}>✓</span>}
                                {yaExiste && !sel && <span style={{ position: 'absolute', top: 4, right: 6, fontSize: 12, color: '#9ca3af', fontWeight: 900 }}>ya</span>}
                                <span style={{ fontSize: 22, fontWeight: 800, color: '#1e3a5f' }}>{a.habitacion}</span>
                                <span style={s.tareaOpcionLabel}>{a.nombre}</span>
                            </button>
                          );
                        })}
                        </div>
                      )}
                    </div>
                  );
                })}
                {/* Sección 3: banos/salon/cocina no organizados */}
                {["banos", "salon", "cocina"].filter(t => !(plan?.[t] === 1 || plan?.[t] === "1")).length > 0 && (
                  <div style={s.formGrupo}>
                    <label style={{ ...s.formLabel, fontSize: 15, color: '#6b7280', fontWeight: 700, marginBottom: 10 }}>Tareas no organizadas</label>
                    <div style={s.tareaGrid}>
                      {["banos", "salon", "cocina"].filter(t => !(plan?.[t] === 1 || plan?.[t] === "1")).map(tarea => {
                        const key = `toggle-${tarea}`;
                        const sel = !!extrasSeleccionados.find(x => x.key === key);
                        const yaExiste = extras.some(e => e.tarea_real === tarea);
                        return (
                          <button key={key} type="button"
                            style={{ ...s.tareaOpcion, ...(sel ? s.tareaOpcionActiva : {}), ...(yaExiste ? { opacity: 0.4, cursor: 'not-allowed' } : {}), position: 'relative' }}
                            onClick={() => !yaExiste && toggleExtraSelec(key, tarea, null, TAREAS_LABEL[tarea])}
                            disabled={yaExiste}
                          >
                            {sel && <span style={{ position: 'absolute', top: 4, right: 6, fontSize: 14, color: '#1d4ed8', fontWeight: 900 }}>✓</span>}
                            {yaExiste && !sel && <span style={{ position: 'absolute', top: 4, right: 6, fontSize: 12, color: '#9ca3af', fontWeight: 900 }}>ya</span>}
                            <span style={{ fontSize: 28 }}>{TAREAS_ICONO[tarea]}</span>
                            <span style={s.tareaOpcionLabel}>{TAREAS_LABEL[tarea]}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
                {extrasSeleccionados.length > 0 && (
                  <div style={{ background: '#eff6ff', border: '2px solid #93c5fd', borderRadius: 12, padding: '10px 14px', marginBottom: 4, fontSize: 14, color: '#1e3a5f', fontWeight: 700 }}>
                    Seleccionados ({extrasSeleccionados.length}): {extrasSeleccionados.map(x => x.label).join(', ')}
                  </div>
                )}
              </>
            ) : (
              <div style={s.formGrupo}>
                <label style={s.formLabel}>Tarea real</label>
                <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", borderRadius: 12, background: "#dbeafe", border: "2px solid #3b82f6" }}>
                  <span style={{ fontSize: 28 }}>{TAREAS_ICONO[modalCambio.tarea_orig]}</span>
                  <span style={{ fontSize: 16, fontWeight: 700, color: "#1e3a5f" }}>{TAREAS_LABEL[modalCambio.tarea_orig]}</span>
                  <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 4 }}>(misma tarea, otra habitación)</span>
                </div>
              </div>
            )}
            {nuevaTarea && !modalCambio.esExtra && TAREAS_CON_ALUMNO.includes(nuevaTarea) && (
              <div style={s.formGrupo}>
                <label style={s.formLabel}>Alumno/a</label>
                <div style={s.tareaGrid}>
                  {alumnos.filter(a => a.id_alumno !== plan?.[`${nuevaTarea}_id`]).map(a => (
                    <button key={a.id_alumno} type="button"
                      style={{ ...s.tareaOpcion, ...(String(nuevoAlumno) === String(a.id_alumno) ? s.tareaOpcionActiva : {}) }}
                      onClick={() => setNuevoAlumno(a.id_alumno)}
                    >
                      <span style={{ fontSize: 22, fontWeight: 800, color: "#1e3a5f" }}>{a.habitacion}</span>
                      <span style={s.tareaOpcionLabel}>{a.nombre}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div style={s.modalBtns}>
              <button style={s.btnModalCancel} onClick={cerrarModal}>Cancelar</button>
              <button
                style={{ ...s.btnModalOk, ...((modalCambio.esExtra ? extrasSeleccionados.length === 0 : (!nuevaTarea || (TAREAS_CON_ALUMNO.includes(nuevaTarea) && nuevoAlumno === undefined))) ? { background: "#cbd5e1", color: "#94a3b8", cursor: "not-allowed" } : {}) }}
                onClick={confirmarCambio}
                disabled={loadingAction || (modalCambio.esExtra ? extrasSeleccionados.length === 0 : (!nuevaTarea || (TAREAS_CON_ALUMNO.includes(nuevaTarea) && nuevoAlumno === undefined)))}
              >
                {modalCambio.esExtra && extrasSeleccionados.length > 1 ? `Añadir ${extrasSeleccionados.length} extras` : 'Confirmar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CONFIRM CIERRE */}
      {modalConfirmCierre && (
        <div style={s.overlay} onClick={() => setModalConfirmCierre(false)}>
          <div style={{ ...s.modal, textAlign: "center", paddingTop: 36, paddingBottom: 40 }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 64, marginBottom: 12 }}>🔒</div>
            <div style={{ fontSize: 24, fontWeight: 900, color: "#1e3a5f", marginBottom: 10 }}>¿Cerrar el piso?</div>
            <div style={{ fontSize: 16, color: "#6b7280", marginBottom: 28, lineHeight: 1.5 }}>Esta acción no se puede deshacer.<br />Asegúrate de que todo está correcto.</div>
            <button style={{ ...s.btnModalOk, width: "100%", padding: "20px", marginBottom: 12, background: "linear-gradient(135deg, #dc2626, #b91c1c)" }}
              onClick={() => { setModalConfirmCierre(false); setModalCierre(true); }}>
              Sí, cerrar piso
            </button>
            <button style={{ ...s.btnModalCancel, width: "100%", padding: "18px" }} onClick={() => setModalConfirmCierre(false)}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* MODAL CIERRE */}
      {modalCierre && (
        <div style={s.overlay} onClick={e => { if (e.target === e.currentTarget) setModalCierre(false); }}>
          <div style={s.modal}>
            <div style={s.modalTitulo}>🔒 Cerrar el piso</div>
            <div style={s.formGrupo}>
              <label style={s.formLabel}>Comentario (opcional)</label>
              <textarea value={comentarioCierre} onChange={e => setComentarioCierre(e.target.value)} style={s.textarea} placeholder="¿Algo a destacar hoy?" rows={3} />
            </div>
            <label style={{ ...s.formLabel, marginBottom: 12 }}>¿Cómo fue el día?</label>
            <div style={s.valoracionBtns}>
              <button style={s.btnBien} onClick={() => cerrarPiso("bien")} disabled={loadingAction}>👍 Bien</button>
              <button style={s.btnMal} onClick={() => cerrarPiso("mal")} disabled={loadingAction}>👎 Mal</button>
            </div>
            <button style={{ ...s.btnModalCancel, marginTop: 14, width: "100%" }} onClick={() => setModalCierre(false)}>Cancelar</button>
          </div>
        </div>
      )}

      {/* MODAL FOTO */}
      {modalFoto && (
        <div style={s.overlayFoto} onClick={() => setModalFoto(null)}>
          <div style={s.modalFoto} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 24, fontWeight: 900, color: "#1e3a5f", marginBottom: 32, textAlign: "center" }}>📷 Añadir foto</div>
            <label style={s.btnFotoOpcion}>
              <span style={{ fontSize: 64 }}>📷</span>
              <span style={{ fontSize: 22, fontWeight: 800, marginTop: 12 }}>Hacer foto</span>
              <input type="file" accept="image/*" capture="environment" style={{ display: "none" }}
                onChange={e => { if (e.target.files[0]) subirFoto(modalFoto.tarea, modalFoto.tipo, e.target.files[0]); e.target.value = ""; }}
              />
            </label>
            <button style={{ ...s.btnModalCancel, marginTop: 28, width: "100%", padding: "22px", fontSize: 19 }} onClick={() => setModalFoto(null)}>Cancelar</button>
          </div>
        </div>
      )}

      {/* LIGHTBOX */}
      {lightbox && (
        <div style={s.lightboxOverlay} onClick={() => setLightbox(null)}>
          <AuthImage src={lightbox} alt="foto" style={s.lightboxImg} />
          <button style={s.lightboxClose} onClick={() => setLightbox(null)}>✕</button>
        </div>
      )}

      {/* CONFIRMACIÓN CIERRE */}
      {confirmacionCierre && (
        <div style={confirmacionCierre === "bien" ? s.overlayCierreBien : s.overlayCierreMal}>
          <div style={s.modalCierre}>
            <div style={s.cierreEmoji}>{confirmacionCierre === "bien" ? "🎉" : "🙏"}</div>
            <div style={s.cierreTitulo}>{confirmacionCierre === "bien" ? "¡Buen trabajo!" : "Gracias por informar"}</div>
            <div style={s.cierreSubtitulo}>{confirmacionCierre === "bien" ? "Piso cerrado correctamente 👏" : "Piso cerrado. La supervisora verá la valoración 📝"}</div>
            <button style={s.btnCierreVolver} onClick={() => { setConfirmacionCierre(null); navigate("/asistenta"); }}>
              Volver a mis pisos
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const s = {
  page: { maxWidth: 640, margin: "0 auto", padding: "14px 14px 120px", fontFamily: "'Segoe UI', sans-serif", minHeight: "100vh", background: "#f0f4f8" },
  cabecera: { background: "linear-gradient(135deg, #1d4ed8, #1e3a5f)", borderRadius: 20, padding: "18px", marginBottom: 20, display: "flex", alignItems: "center", gap: 14, boxShadow: "0 6px 20px rgba(29,78,216,0.3)" },
  cabeceraInfo: { flex: 1, textAlign: "center" },
  btnVolver: { background: "rgba(255,255,255,0.2)", border: "2px solid rgba(255,255,255,0.4)", borderRadius: 12, padding: "12px 16px", cursor: "pointer", fontWeight: 800, fontSize: 16, color: "#fff", flexShrink: 0 },
  pisoTitulo: { fontSize: 26, fontWeight: 900, color: "#fff" },
  pisoHorario: { fontSize: 16, color: "rgba(255,255,255,0.85)", marginTop: 4, fontWeight: 700 },
  centrado: { textAlign: "center", color: "#888", marginTop: 60, fontSize: 20 },
  errorBox: { textAlign: "center", color: "#991b1b", background: "#fee2e2", borderRadius: 16, padding: "28px", fontSize: 18 },
  vacioBx: { textAlign: "center", padding: "50px 20px", background: "#fff", borderRadius: 20, border: "3px dashed #e5e7eb" },
  vacioTitulo: { fontSize: 20, fontWeight: 700, color: "#374151", marginTop: 8 },
  vacioSub: { fontSize: 16, color: "#9ca3af", marginTop: 6 },
  progresoBx: { background: "#fff", borderRadius: 16, padding: "16px 18px", marginBottom: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
  progresoTexto: { fontSize: 18, fontWeight: 800, color: "#1e3a5f", marginBottom: 10 },
  progresoBarFondo: { height: 14, background: "#e2e8f0", borderRadius: 8, overflow: "hidden" },
  progresoBar: { height: "100%", background: "linear-gradient(90deg, #22c55e, #16a34a)", borderRadius: 8, transition: "width 0.4s" },
  cerradoBanner: { background: "linear-gradient(135deg, #16a34a, #15803d)", color: "#fff", borderRadius: 20, padding: "24px", textAlign: "center", marginBottom: 20, boxShadow: "0 6px 20px rgba(21,128,61,0.35)" },
  cerradoTitulo: { fontSize: 26, fontWeight: 900, marginTop: 6 },
  cerradoComent: { fontSize: 16, marginTop: 8, fontStyle: "italic", opacity: 0.9 },
  seccionTitulo: { fontSize: 18, fontWeight: 900, color: "#1e3a5f", marginBottom: 12, paddingLeft: 2 },
  tareasList: { display: "flex", flexDirection: "column", gap: 14, marginBottom: 28 },
  tareaCard: { borderRadius: 16, overflow: "hidden", boxShadow: "0 3px 12px rgba(0,0,0,0.08)" },
  tareaHeader: { display: "flex", alignItems: "center", padding: "18px 16px", gap: 12 },
  okBadge: { fontSize: 15, fontWeight: 800, border: "2px solid", borderRadius: 10, padding: "6px 10px", flexShrink: 0, whiteSpace: "nowrap" },
  tareaIcono: { fontSize: 34, flexShrink: 0 },
  tareaLabel: { fontSize: 21, fontWeight: 800, color: "#1e3a5f" },
  tareaAlumno: { fontSize: 17, color: "#374151", fontWeight: 600, marginTop: 4 },
  tareaBody: { padding: "4px 16px 20px" },
  btnGrupo: { display: "flex", gap: 10, paddingTop: 10, flexWrap: "wrap" },
  btnMarca: { flex: 1, minWidth: 110, padding: "18px 8px", borderRadius: 14, border: "2px solid", fontSize: 18, fontWeight: 800, cursor: "pointer" },
  btnHecho: { background: "#f0fdf4", borderColor: "#86efac", color: "#16a34a" },
  btnHechoActivo: { background: "#16a34a", borderColor: "#15803d", color: "#fff" },
  btnNoHecho: { background: "#fff1f2", borderColor: "#fca5a5", color: "#dc2626" },
  btnNoHechoActivo: { background: "#dc2626", borderColor: "#b91c1c", color: "#fff" },
  btnCambiar: { flex: 1, minWidth: 100, padding: "16px 8px", borderRadius: 12, border: "2px solid #93c5fd", background: "#eff6ff", color: "#1d4ed8", fontSize: 16, fontWeight: 700, cursor: "pointer" },
  btnCambiarDis: { opacity: 0.4, cursor: "not-allowed", background: "#f1f5f9", border: "2px solid #e2e8f0", color: "#9ca3af" },
  cambiosList: { marginBottom: 12 },
  cambioCard: { background: "#fff7ed", border: "2px solid #fed7aa", borderRadius: 12, padding: "12px 14px", marginBottom: 8 },
  cambioCardRow: { display: "flex", alignItems: "center", gap: 8 },
  cambioParte: { flex: 1, minWidth: 0 },
  cambioParteLabel: { fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 },
  cambioParteVal: { fontSize: 14, fontWeight: 700, color: "#1e3a5f" },
  cambioArrow: { fontSize: 22, color: "#d97706", fontWeight: 900, flexShrink: 0 },
  btnDesmarcar: { display: "block", width: "100%", marginTop: 8, padding: "12px", borderRadius: 10, border: "2px solid #e2e8f0", background: "#f8fafc", color: "#6b7280", fontSize: 15, fontWeight: 700, cursor: "pointer" },
  btnDel: { background: "#fee2e2", border: "2px solid #fca5a5", cursor: "pointer", color: "#dc2626", fontWeight: 800, fontSize: 20, padding: "4px 10px", flexShrink: 0, borderRadius: 8 },
  fotosSection: { marginBottom: 12 },
  fotoFila: { marginBottom: 14 },
  fotoTipoLabel: { fontSize: 16, fontWeight: 800, color: "#374151", display: "block", marginBottom: 8 },
  fotoList: { display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" },
  fotoItem: { position: "relative" },
  fotoThumb: { width: 86, height: 86, objectFit: "cover", borderRadius: 10, border: "3px solid #e2e8f0", display: "block", cursor: "pointer" },
  btnFotoDel: { position: "absolute", top: -8, right: -8, background: "#dc2626", color: "#fff", border: "none", borderRadius: "50%", width: 26, height: 26, cursor: "pointer", fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 },
  btnFotoAdd: { width: 86, height: 86, display: "flex", alignItems: "center", justifyContent: "center", background: "#f8fafc", border: "3px dashed #93c5fd", borderRadius: 10, cursor: "pointer", fontSize: 32, color: "#3b82f6" },
  btnFotoOpcion: { display: "flex", flexDirection: "column", alignItems: "center", width: "100%", padding: "32px 16px", borderRadius: 20, border: "3px solid #e2e8f0", background: "#f8fafc", cursor: "pointer", fontFamily: "inherit", boxSizing: "border-box" },
  overlayFoto: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "flex-end", justifyContent: "center", zIndex: 1000 },
  modalFoto: { background: "#fff", borderRadius: "20px 20px 0 0", padding: "28px 20px 40px", width: "calc(100% - 32px)", maxWidth: 640, maxHeight: "90vh", overflowY: "auto", boxSizing: "border-box" },
  extrasSection: { marginBottom: 20 },
  extraItem: { display: "flex", alignItems: "center", padding: "16px 16px", background: "#fefce8", border: "2px solid #fde047", borderRadius: 14, marginBottom: 10, fontSize: 18, color: "#713f12" },
  btnExtra: { display: "block", width: "100%", padding: "20px", borderRadius: 14, border: "3px dashed #fde047", background: "#fefce8", color: "#854d0e", fontSize: 19, fontWeight: 800, cursor: "pointer" },
  btnCerrar: { position: "fixed", bottom: "var(--fichaje-h, 0px)", left: 0, right: 0, margin: "0 auto", maxWidth: 640, padding: "22px", border: "none", background: "linear-gradient(135deg, #1d4ed8, #1e40af)", color: "#fff", fontSize: 22, fontWeight: 900, cursor: "pointer", textAlign: "center", boxShadow: "0 -4px 20px rgba(29,78,216,0.35)", zIndex: 100 },
  btnCerrarDis: { background: "#d1d5db", color: "#9ca3af", boxShadow: "none", cursor: "not-allowed" },
  cerrarHint: { fontSize: 15, fontWeight: 500, marginTop: 4, opacity: 0.85 },
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "flex-end", justifyContent: "center", zIndex: 1000 },
  modal: { background: "#fff", borderRadius: "20px 20px 0 0", padding: "28px 20px 40px", width: "100%", maxWidth: 640, maxHeight: "85vh", overflowY: "auto" },
  overlayCierreBien: { position: "fixed", inset: 0, background: "linear-gradient(160deg, #16a34a 0%, #15803d 40%, #065f46 100%)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: "24px" },
  overlayCierreMal: { position: "fixed", inset: 0, background: "linear-gradient(160deg, #d97706 0%, #b45309 40%, #92400e 100%)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: "24px" },
  modalCierre: { textAlign: "center", maxWidth: 420, width: "100%" },
  cierreEmoji: { fontSize: 100, lineHeight: 1, marginBottom: 24, filter: "drop-shadow(0 8px 24px rgba(0,0,0,0.25))" },
  cierreTitulo: { fontSize: 40, fontWeight: 900, color: "#fff", marginBottom: 10, letterSpacing: "-0.5px", textShadow: "0 2px 12px rgba(0,0,0,0.2)" },
  cierreSubtitulo: { fontSize: 20, fontWeight: 700, color: "rgba(255,255,255,0.95)", marginBottom: 12, lineHeight: 1.4 },
  btnCierreVolver: { width: "100%", padding: "22px", borderRadius: 20, border: "3px solid rgba(255,255,255,0.4)", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 20, fontWeight: 900, cursor: "pointer" },
  modalTitulo: { fontSize: 24, fontWeight: 900, color: "#1e3a5f", marginBottom: 22 },
  formGrupo: { marginBottom: 18 },
  formLabel: { display: "block", fontSize: 18, fontWeight: 800, color: "#374151", marginBottom: 12 },
  select: { width: "100%", padding: "16px", fontSize: 18, borderRadius: 12, border: "2px solid #e2e8f0", background: "#fff" },
  textarea: { width: "100%", padding: "14px", fontSize: 17, borderRadius: 12, border: "2px solid #e2e8f0", resize: "vertical", fontFamily: "inherit", boxSizing: "border-box" },
  modalBtns: { display: "flex", gap: 12, marginTop: 24 },
  tareaGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  tareaOpcion: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8, padding: "20px 10px", borderRadius: 16, border: "3px solid #e2e8f0", background: "#f8fafc", cursor: "pointer", fontFamily: "inherit" },
  tareaOpcionActiva: { border: "3px solid #1d4ed8", background: "#eff6ff" },
  tareaOpcionLabel: { fontSize: 15, fontWeight: 800, color: "#1e3a5f", textAlign: "center", lineHeight: 1.2 },
  btnModalCancel: { flex: 1, padding: "18px", borderRadius: 14, border: "3px solid #e2e8f0", background: "#fff", color: "#374151", fontSize: 18, fontWeight: 700, cursor: "pointer" },
  btnModalOk: { flex: 2, padding: "18px", borderRadius: 14, border: "none", background: "#1d4ed8", color: "#fff", fontSize: 19, fontWeight: 800, cursor: "pointer" },
  valoracionBtns: { display: "flex", gap: 14, marginTop: 10, marginBottom: 4 },
  btnBien: { flex: 1, padding: "28px 10px", borderRadius: 16, border: "3px solid #16a34a", background: "#f0fdf4", color: "#15803d", fontSize: 26, fontWeight: 900, cursor: "pointer" },
  btnMal: { flex: 1, padding: "28px 10px", borderRadius: 16, border: "3px solid #dc2626", background: "#fff1f2", color: "#b91c1c", fontSize: 26, fontWeight: 900, cursor: "pointer" },
  lightboxOverlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000, padding: 16 },
  lightboxImg: { maxWidth: "100%", maxHeight: "90vh", borderRadius: 12, objectFit: "contain", boxShadow: "0 8px 40px rgba(0,0,0,0.5)" },
  lightboxClose: { position: "fixed", top: 18, right: 18, background: "rgba(255,255,255,0.15)", color: "#fff", border: "none", borderRadius: "50%", width: 40, height: 40, fontSize: 18, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
};

export default EjecucionPiso;
